// Func = limiting Scope for this file
self.fetch||(self.fetch=function(e,n){return n=n||{},new Promise(function(t,s){var r=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(r.status/100|0),statusText:r.statusText,status:r.status,url:r.responseURL,text:function(){return Promise.resolve(r.responseText)},json:function(){return Promise.resolve(JSON.parse(r.responseText))},blob:function(){return Promise.resolve(new Blob([r.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var c in r.open(n.method||"get",e,!0),r.onload=function(){r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},r.onerror=s,r.withCredentials="include"==n.credentials,n.headers)r.setRequestHeader(c,n.headers[c]);r.send(n.body||null)})});





var lastScrollTop = 0;


(function(){

	$(document).ready(function () {


		setTimeout(function(){
			$('.uvp').addClass('in');
			$(".menu__item-tab.js-menu-tab.active.Dinner").click()
		},500)

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		//Acts when scroll down page.
		// $(window).scroll(function (event) {
		// 	scrollDown();
		// });

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	$('.sym-slides').slick();
	
}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate-fade-2');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}
}

$('.toggle-table').click(function(){
	//$(this).toggleClass('open');
	$('.drop-table').toggleClass('open');
})
$('.close-menu').click(function(){
	$('.drop-table').removeClass('open');
})

const js_anchor = document.getElementsByClassName('js-anchor');
const anchor_length = js_anchor.length;
for(let i = 0; i < anchor_length; i++ ){
	js_anchor[i].addEventListener('click', function(event){
		event.preventDefault();
		let st = window.pageYOffset || document.documentElement.scrollTop;
		let target = js_anchor[i].getAttribute('data-href');
		target = document.querySelector(target);
		const viewportOffset = target.getBoundingClientRect();
		const offset_top = st+(viewportOffset.top);
		$('html,body').animate({
			scrollTop: offset_top - 90
		},1200);
	});
}
$('.home-menu__slider').slick({
	accessibility: false,
	fade: true,
	draggable: false,
	arrows: false
});
$('.home-menu__nav button:first-child').show();
$('.home-menu__nav button h3').click(function(){
	if($(this).parent('button').hasClass('active')){

	}else{
		let slideIndex = $(this).parent('button').index();
		$( '.home-menu__slider').slick('slickGoTo',slideIndex );
		$(".home-menu__nav button").removeClass('active');
		$(this).parent('button').addClass('active');
		// $('.home-menu__item-content').slideUp(500);
		// $(this).siblings('.home-menu__item-content').slideDown(500);
	}
});	

function msieversion() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
    {
	  const image_fit = document.getElementsByClassName('image-fit__wrapper');
	  const cont_fit = document.getElementsByClassName('home-gallery');
      for(let i = 0; i < image_fit.length; i++ ){
        const this_image = image_fit[i].getElementsByTagName('img')[0];
        const image_data = this_image.dataset.srcset;
        const image_src = this_image.getAttribute('src');
		image_fit[i].classList.add('ie-bg');
		cont_fit[0].classList.add('ms-bot');
        if(image_data){
          image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
        }else{
          image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
        }

      }
    }
    else
    {
      console.log('other browser');
    }

    return false;
}


msieversion()


function setMenuListeners(classTabLink,container){ //ClassTabLink -> class of each tab of the restaurant menu //container -> div where will load the info
	for (let i = 0; i < classTabLink.length; i++) {
		classTabLink[i].addEventListener('click', function(event) {
			for (let i = 0; i < classTabLink.length; i++) {
				classTabLink[i].classList.remove("active");
			}
			this.classList.add("active");
			let menuid = this.dataset.menuid;
			let menuname = this.dataset.menuname;
			let menuimage = this.dataset.menuimage;
			loadMenuRestaurant(container,menuid,menuname,menuimage,event.isTrusted);
		});
	}
	
}

document.addEventListener('DOMContentLoaded',(e) => {

	let ancormenu = window.location.hash;

	if(ancormenu == "#menu-3199"){
		let buttomclick = document.querySelector('button#menu-3199');
		console.log(buttomclick);
		setTimeout( () =>{
			buttomclick.click();
		},1000)
	}
})


function loadMenuRestaurant(container,menuid,menuname,menuimage,isTrusted){ //container -> div where will load the info // menuid -> data-menuid in each tab // isTrusted -> if this is an user event
	//fetch(`${site_url}ajax/functions.php?operation=getMenuCategory&menuid=`+menuid+`&menuname=`+menuname+`&menuimage=`+menuimage,{method: "GET"}) //call the URL where we make all the html content based in the menu id
	console.log(site_url);
	fetch(`${site_url}ajax/functions.php?operation=getMenuCategory&menuid=${menuid}&client_folder=${CLIENT_FOLDER}`,{method: "GET"}) //call the URL where we make all the html content based in the menu id
	.then((resp) => resp.json()) // Transform the data into json
	.then((data) => {
		container.innerHTML = data.html; //set data response via fetch in the container
		console.log(data);

	})
	.then(() => {
		if(isTrusted != false){ // don't scroll when it's not an user event
			//container.scrollIntoView({ behavior: 'smooth', block: 'start' });
			container.classList.remove('active-animate');
			setTimeout(function () {
				container.classList.add('active-animate');
			},200)
		}
	});
}

// limiting Scope for this file
(function(){
	if(document.getElementsByClassName('menu__js-container-products').length > 0){
		let container = document.querySelector(".menu__js-container-products");

		//if is mobile call to the mobile function, any other device call the desktop function
		let classTabMobile = document.querySelectorAll('.js-tab-mobile');
		if(classTabMobile.length > 0){
			//Load the first tab of the restaurant menu by default
			loadMobileMenu(classTabMobile[0].parentElement,false);
		}else{
			let classTabLink = document.querySelectorAll('.js-menu-tab');
			setMenuListeners(classTabLink, container);
			loadMenuRestaurant(container,classTabLink[0].dataset.menuid,classTabLink[0].dataset.menuname,classTabLink[0].dataset.menuimage,false); // Put the first tab as active, load the info and tell that isn't an user event (we don't want a scroll)
		}
	}
})();

(function(){
	document.addEventListener('DOMContentLoaded', () => {

		document.querySelectorAll('[data-getrooms]').forEach( (btn, i) => {
			btn.addEventListener('click', () => {

				document.querySelectorAll('.roomsTabs_navItem').forEach( b => b.classList.remove('active') );
				document.querySelectorAll('.roomsTabs_navItem').forEach( b => b.setAttribute('aria-selected','false') );
				btn.classList.add('active');
				btn.setAttribute('aria-selected','true');
			});

			if ( i === 0 ) btn.click();
		});
	});

})();
